import {useState} from 'react';
import {useQuery} from 'react-query';
import {useAlerts} from 'react-native-paper-alerts';
import auth from '@react-native-firebase/auth';

import {getApiUrl, getReleaseStream, ReleaseStreams} from '../AppConfig';
import {useAppSettings} from '../components/AppSettings';

// The auth idToken should always work but results in "expired" tokens sometimes,
// between cloud dev environment functions and emulator

// Working around currently by using fixed API Key
export async function createHeaders(): Promise<any> {
  return {
    'Content-Type': 'application/json',
    Authorization:
      getReleaseStream() === ReleaseStreams.local
        ? 'EquityResidencesApiKey-v1 PgCIXSt81xdbjHA8t2qsGvtOWpPOxnXoBX4tvk2cg8N54RnuUlK9WFsme3eEB0RoRS8MTn87jvcrJCCfDjQyjC0ZNugBDyBpwNd4JwUseijgWdP3n47yrfojQS7nO5JU'
        : `Bearer ${await auth().currentUser!!.getIdToken()}`,
  };
}

// NOTE! Not safe to use if query params already exist. KISS at the moment
async function addHeadersAsParams(url: string): Promise<string> {
  const headers = await createHeaders();
  return url + '?sauce=' + btoa(JSON.stringify(headers));
}

export function useCreditBalanceReport(
  year: string,
): {[keyof: string]: {[keyof: string]: number}} | undefined {
  const Alert = useAlerts();
  const appSettings = useAppSettings();
  const [seenError, setSeenError] = useState(false);
  const results = useQuery('creditBalanceReport' + year, () =>
    fetchCreditBalance(year),
  );
  if (results.isLoading) {
    console.log('loading credit balance report for year ' + year);
    return;
  }
  if (results.isError) {
    if (!seenError) {
      Alert.alert('Error', '' + results.error, [{text: appSettings.t('OK')}]);
      setSeenError(true);
    }
    return;
  }
  console.log('returning credit balances for year ' + year);
  return results.data;
}

export async function fetchCreditBalance(year: string): Promise<{}> {
  const accountAPI = getApiUrl() + 'report/credits/' + year;
  const result = await fetch(accountAPI, {
    headers: await createHeaders(),
    method: 'GET',
  });
  const data = (await result.json()).data;
  if (result.status === 500 || data.error !== undefined) {
    throw new Error(data.error);
  }
  console.log('return code from API call was ' + result.status);
  console.log('credit balances result:', JSON.stringify(data, null, 2));
  return data as {};
}

export async function getLimitedPartnerCreditUsageURL(
  year: string,
): Promise<string> {
  const accountAPI = getApiUrl() + 'report/limitedPartnerCreditUsage/' + year;
  return addHeadersAsParams(accountAPI);
}

export async function getCreditUsageByPropertyURL(
  year: string,
): Promise<string> {
  console.log('requesting property credit usage report');
  const accountAPI = getApiUrl() + 'report/propertyCreditUsage/' + year;
  return addHeadersAsParams(accountAPI);
}
